module.exports = __webpack_public_path__ + "img/logo_login.cdf84e22.png";